import { URL_API } from "../../../general/init/url";

export const API_SESSION_INFO = (session) =>
  URL_API + "/api/project/assessmentMethodSession/sessionInfo/" + session;
export const API_USER_LIST = (session) =>
  URL_API + "/api/project/assessmentMethodSession/availableUid/" + session;
